// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__4Qh2k","noUnderline":"link_noUnderline__uoVGq","naked":"link_naked__gvACP"};